export default {
  //TODO: REMOVE AND USE NEW TRANSLATIONS
  LOADING_APPOINTMENT: `Cargando cita...`,
  LOADING_VIDEO: `Cargando vídeo...`,
  LANDING_PAGE_HEADING: `¡Bienvenido a tu cita en línea!`,
  LANDING_PAGE_APPT_DETAILS: `Cita con <1/> {{providerName}} <1/> programada para`,
  LANDING_PAGE_BEFORE_START: `Antes de comenzar, ingresa tu nombre y la relación con el paciente.`,
  LANDING_PAGE_NAME_PLACEHOLDER: `Nombre, paciente/madre/cuidador/etc.`,
  LANDING_PAGE_TERMS: `Al unirme al encuentro de telesalud, acepto los `,
  LANDING_PAGE_TERMS_CONSENT: `Al unirme al encuentro de telesalud, acepto el `,
  LANDING_PAGE_TERMS_NO_MARKUP: `Al unirme al encuentro de telesalud, acepto los Términos de uso y el Consentimiento informado del paciente de athenaTelehealth.`,
  LANDING_PAGE_TERMS_HEADING: `Términos de uso y Consentimiento informado del paciente de athenaTelehealth`,
  LANDING_PAGE_TERMS_CLOSE: `Cerrar`,
  LANDING_PAGE_READY_BTN: `Ok, estoy listo`,
  LANDING_PAGE_NAME_LABEL: `Escribe tu nombre, seguido de tu relación con el paciente`,

  CALL_SUMMARY_PAGE_HEADING: `Gracias`,
  CALL_SUMMARY_DETAILS: `Tu cita con {{provider}} finalizó.`,
  CALL_SUMMARY_FOLLOWUP: `Seguiremos con instrucciones de cuidado si es necesario.
  Mientras tanto, llama a tu proveedor si tienes preguntas.`,
  CALL_SUMMARY_CUTOFF: `Si tu llamada se cortó, vuelve a unirte usando el enlace de invitación.`,
  CALL_SUMMARY_CLOSE: `Ya puedes cerrar esta ventana.`,

  FEEDBACK_THOUGHTS: `¿Tienes algún comentario?`,
  FEEDBACK_BTN: `Comenta`,

  BLOCKED_PATIENT_PRIVACY: `Lo sentimos, el consultorio ha solicitado privacidad para esta sesión de telesalud`,
  BLOCKED_PATIENT_CONTACT: `Contacta con tu consultorio si crees que has recibido este mensaje por error.`,

  //NEW TRANSLATIONS
  LANDING_PAGE_APPT_DETAILS_INTRO: `Prepárate para tu visita con`,
  LANDING_PAGE_APPT_DETAILS_PROVIDER: `{{providerName}} el `,
  LANDING_PAGE_NAME_LABEL_2: `¿Cuál es tu nombre completo?`,
  LANDING_PAGE_NAME_PLACEHOLDER_2: `- Teclea tu nombre - `,
  LANDING_PAGE_PATIENT_LABEL: `¿Tú eres el(la) paciente?`,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_1: `Sí, soy el(la) paciente`,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_2: `No, soy el(la) cuidador(a)`,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_3: `No, soy un miembro de la familia`,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_4: `No, soy un(a) amigo(a)`,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_5: `No, soy otro proveedor de servicios médicos`,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_6: `No, soy un traductor`,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_7: `Otro`,
  LANDING_PAGE_CHECKBOX_DISCLAIMER: `Al unirme al encuentro de telehealth (telesalud), acepto los Términos de Uso y el Consentimiento Informado del Paciente de athenaTelehealth.`,
  LANDING_PAGE_SIGNPOST: `Haz clic en <strong>Permitir</strong> cuando tu navegador pida acceso a tu cámara y micrófono.`,
  LANDING_PAGE_NEXT_BUTTON: `Siguiente`,
  LANDING_PAGE_CONSENT_ERROR: `Necesitamos tu consentimiento. Marca la casilla para continuar.`,
  LANDING_PAGE_NAME_ERROR: `Necesitamos tu nombre para continuar.`,
  LANDING_PAGE_APPT_START_DATE: `{{date}} a las {{time}}`,
  LANDING_PAGE_CONSENT_HEADING: `Consentimiento para tratamiento de telesalud`,

  CALL_SUMMARY_PAGE_THANK_YOU: `Gracias {{patientName}},`,
  CALL_SUMMARY_PAGE_HEADING_2: `Tu visita ha terminado`,
  CALL_SUMMARY_PAGE_FOLLOW_UP: `Llama a tu equipo de asistencia médica si tienes alguna pregunta de seguimiento.`,
  CALL_SUMMARY_PAGE_SIGNPOST: `¿Quieres programar visitas, enviar mensajes a tu equipo de asistencia médica o estar al tanto de tu salud en línea?`,
  CALL_SUMMARY_PAGE_SIGNPOST_LINK: `Ir al Portal del Paciente`,
  CALL_SUMMARY_PAGE_REPORT_BUTTON: `Reportar un problema técnico`,
  CALL_SUMMARY_PAGE_SFPI_BANNER_CONTENT: `¿Piensas algo?`,
  CALL_SUMMARY_PAGE_SFPI_BANNER_BUTTON: `Danos tu opinión`,

  READINESS_CHECK_WELCOME: `Bienvenido {{patientName}},`,
  READINESS_CHECK_START: `Primero, verifiquemos tu configuración`,
  READINESS_CHECK_AUDIO_OUTPUT_CHECK_LOADING: `Cargando tus {{deviceName}}`,
  READINESS_CHECK_AUDIO_INPUT_CHECK_LOADING: `Cargando tu {{deviceName}}`,
  READINESS_CHECK_VIDEO_INPUT_CHECK_LOADING: `Cargando tu {{deviceName}}`,
  READINESS_CHECK_AUDIO_OUTPUT: `altavoces ...`,
  READINESS_CHECK_AUDIO_INPUT: `micrófono ...`,
  READINESS_CHECK_VIDEO_INPUT: `cámara ...`,
  READINESS_CHECK_NETWORK_CHECK: `Verificando tu red ...`,
  READINESS_CHECK_NETWORK_CHECK_ISSUE_ALERT: `Fue detectado un problema de red.`,
  READINESS_CHECK_NETWORK_ERROR_TITLE: `Error de la red`,
  READINESS_CHECK_NETWORK_ERROR_TITLE_CONNECTION_ISSUE: `Problemas de conexión`,
  READINESS_CHECK_NETWORK_ERROR_CONTENT: `Fue detectado un problema de la red. Intenta comenzar athenaTelehealth de nuevo. Si sigues viendo este error, llama a tu consultorio.`,
  READINESS_CHECK_NETWORK_ERROR_CONTENT_CONNECTION_ISSUE: `Deshabilite su VPN, revise su firewall, o usa su red móvil (pueden aplicar tarifas de datos).`,
  READINESS_CHECK_NETWORK_ERROR_TRY_AGAIN: `Intentar otra vez`,
  READINESS_CHECK_NETWORK_ERROR_CANCEL: `Cancelar`,

  READINESS_CHECK_ISSUE_ALERT_SPEAKER: `Altavoz no detectado.`,
  READINESS_CHECK_ISSUE_ALERT_MICROPHONE: `Micrófono no detectado.`,
  READINESS_CHECK_ISSUE_ALERT_MICROPHONE_AND_SPEAKER: `Micrófono y altavoz no detectados.`,
  READINESS_CHECK_ISSUE_ALERT_CAMERA: `Cámara no detectada.`,
  READINESS_CHECK_ISSUE_ALERT_CAMERA_AND_SPEAKER: `Cámara y altavoz no detectados.`,
  READINESS_CHECK_ISSUE_ALERT_CAMERA_AND_MICROPHONE: `Cámara y micrófono no detectados.`,
  READINESS_CHECK_ISSUE_ALERT_NO_INPUTS: `Dispositivos de entrada no detectados.`,

  LANGUAGE_BUTTON: `Do you prefer english?`,
  LANGUAGE_BUTTON_SHORT: `English`,

  LOADING_APPOINTMENT_2: `Cargando tu cita...`,
  LOADING_APPOINTMENT_3: `Cargando tu visita virtual...`,

  IMAGE_ALT_CATWOMAN: `Mujer en casa con gato`,
  IMAGE_ALT_TREEDOG: `Gracias árbol y perro`,

  FEEDBACK_QUESTION_AUDIO: `¿Cómo fue tu experiencia con la calidad del audio?`,
  FEEDBACK_QUESTION_VIDEO: `¿Cómo fue tu experiencia con la calidad del video?`,
  FEEDBACK_QUESTION_OVERALL: `¿Cómo fue tu experiencia de calidad de llamada en general?`,
  FEEDBACK_GIVE_MORE_FEEDBACK: `Danos más información`,
  FEEDBACK_BAD: `Mala`,
  FEEDBACK_EXCELLENT: `Excelente`,
  FEEDBACK_THANKYOU: `Gracias por tu respuesta`,

  EXPERIENCE_RATING_SUBMIT: 'Enviar calificación',
  EXPERIENCE_RATING_WARNING: 'Seleccione una calificación para enviar.',

  // re-skinned readiness check page
  READINESS_CHECK_PAGE_STATUS: `Preparándote`,
  READINESS_CHECK_PAGE_HEADING: `Configurando tu(s) dispositivo(s)...`,
  READINESS_CHECK_PAGE_SUB_TEXT: `Permanece en esta página y la llamada comenzará cuando el equipo médico esté listo.`,

  // duplicated here because we re-skinned the readines check page but want to keep the same i18n namespaces for testing etc
  WAITING_ROOM_SIGNPOST_CONNECTIVITY: `Consejo profesional: ¿Tu conexión a Internet es tan potente como podría ser? Si no lo es, acércate a tu enrutador WiFi.`,
  WAITING_ROOM_SIGNPOST_PRIVACY: `Consejo profesional: ¿Estás en un lugar privado? Si no es así, muévete a un lugar donde te sientas cómodo haciendo preguntas sobre tu salud.`,
  WAITING_ROOM_SIGNPOST_STREAMING: `Consejo profesional: ¿Hay alguna otra persona compartiendo tu ancho de banda de Internet? Asegúrate de que nadie esté transmitiendo videos o jugando videojuegos.`,
  WAITING_ROOM_SIGNPOST_UNUSED_TABS: `Consejo profesional: ¿Has cerrado alguna aplicación y pestaña del navegador no utilizadas? Asegúrate de que tu ancho de banda sea lo más potente posible.`,
  WAITING_ROOM_SIGNPOST_DO_NOT_DISTURB: `Consejo profesional: activa la opción "No molestar" en tu equipo durante al menos 1 hora para evitar que se interrumpa si alguien te llama.`,

  // footer
  FOOTER_A11Y_STATEMENT: `Declaración de Accesibilidad`,

  // Page titles
  TITLE_VISIT_SIGN_IN: `Telehealth - Inicio de sesión de la visita`,
  TITLE_READINESS_CHECK: `Telehealth - Control de la preparación`,
  TITLE_WAITING_ROOM: `Telehealth - Sala de espera`,
  TITLE_VISIT_IN_PROGRESS: `Telehealth - Visita en progreso`,
  TITLE_VISIT_ENDED: `Telehealth - Visita finalizada`,
  TITLE_INVALID_VISIT_LINK: `Telehealth - Enlace inválido de la visita`,
  TITLE_DEVICE_CHECK: `Telehealth - Verificación del dispositivo`,
  TITLE_SPEAKER_CHECK: `Telehealth - Comprobación del altavoz`,
  TITLE_MICROPHONE_CHECK: `Telehealth - Comprobación del micrófono`,
  TITLE_CAMERA_CHECK: `Telehealth - Comprobación de la cámara`,
  TITLE_DEVICE_CHECK_COMPLETE: `Telehealth - Verificación del dispositivo completada`,
  TITLE_FAQ: `Telehealth - Preguntas frecuentes (FAQ) y solución de problemas`,
  TITLE_DEVICE_ACCESS_ISSUE: `Telehealth - Problema de acceso al dispositivo`,
};
